import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6ceadfb1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ManageReportExportAsPDFViewContainer bothCenter"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "PDF头设置", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "第N期设置:", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发布方设置", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发布时间设置:", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "数据时间区间", -1));
const _hoisted_7 = {
  class: "colFlex mt100",
  style: {
    "border": "white 1px solid"
  },
  id: "pdf"
};
const _hoisted_8 = {
  class: "ft70 boldFont",
  style: {
    "color": "red"
  }
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "小河街道共治大队工作周报", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应急联动工作情况", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "。", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "具体小组应急联动情况", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "商铺治理", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "风险隐患社区分布情况", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "风险隐患类型分布情况", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "具体小组检查情况", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "具体人员检查情况", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "事件上报工作情况", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "单车清理分布情况", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "出店分布情况", -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pdfDot"
}, null, -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "无证劝离情况", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/thzg.png",
  style: {
    "width": "140px"
  }
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报告提供方：浙江泰和智谷科技有限公司", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_SinglePieChart = _resolveComponent("SinglePieChart");
  const _component_SimpleVerticalBarChart = _resolveComponent("SimpleVerticalBarChart");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter",
    style: {
      "width": "80%"
    },
    gutter: "20"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.pdf.header,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.pdf.header = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_3]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.pdf.reportIndex,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.pdf.reportIndex = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter wd100 mt16",
    style: {
      "width": "80%"
    },
    gutter: "20"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.pdf.publicInst,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.pdf.publicInst = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 4,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.pdf.publicTime,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.pdf.publicTime = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter wd100 mt16",
    style: {
      "width": "80%"
    },
    gutter: "20"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_date_picker, {
        "value-format": "YYYY-MM-DD",
        format: "YYYY-MM-DD",
        modelValue: $data.pdf.dateRange,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.pdf.dateRange = $event),
        onChange: $options.onDateChange,
        type: "daterange"
      }, null, 8, ["modelValue", "onChange"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.preview
      }, {
        default: _withCtx(() => [_createTextVNode("导出前先预览")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.generatePDF,
        disabled: $data.exporting
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.exporting ? '请稍等...' : '导出为PDF'), 1)]),
        _: 1
      }, 8, ["onClick", "disabled"])]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_8, _toDisplayString($data.pdf.header), 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter boldFont ft20"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "第" + _toDisplayString($data.pdf.reportIndex) + "期", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter",
    style: {
      "border-bottom": "3px red solid"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: "leftCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.pdf.publicInst), 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12,
      class: "rightCenter"
    }, {
      default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.pdf.publicTime), 1)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "ft30 boldFont bothCenter mt20"
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable"
  }, {
    default: _withCtx(() => [_hoisted_10, _hoisted_11]),
    _: 1
  }), $data.policeEventSinglePieChart ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "mt16"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "     本周小河街道共治大队共联动处置警情" + _toDisplayString($data.policeEventThisWeekTotal) + "起，" + _toDisplayString($data.policeEventYoy), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.policeEventSinglePieChart, (p, pi) => {
      return _openBlock(), _createElementBlock("span", {
        key: `policeEventThisWeekTotal_${pi}`
      }, "，" + _toDisplayString(pi > 0 ? '' : '其中') + _toDisplayString(p.name) + _toDisplayString(p.value) + "起", 1);
    }), 128)), _hoisted_12]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_table, {
    data: $data.policeEventSinglePieChart,
    border: "",
    "header-cell-style": {
      backgroundColor: '#4d93ef',
      color: 'white'
    },
    style: {
      "width": "100%",
      "margin-top": "16px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "idx",
      label: "序号"
    }), _createVNode(_component_el_table_column, {
      prop: "item",
      label: "工作事项"
    }), _createVNode(_component_el_table_column, {
      prop: "thisWeek",
      label: "本周数量"
    }), _createVNode(_component_el_table_column, {
      prop: "lastWeek",
      label: "上周数量"
    }), _createVNode(_component_el_table_column, {
      prop: "yoy",
      label: "同比"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [$data.policeEventSinglePieChart ? (_openBlock(), _createBlock(_component_SinglePieChart, {
      key: 0,
      id: "yjldqk",
      "pie-data": $data.policeEventSinglePieChart
    }, null, 8, ["pie-data"])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable"
  }, {
    default: _withCtx(() => [_hoisted_13, _hoisted_14]),
    _: 1
  }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.actionGroups, (g, gi) => {
    return _openBlock(), _createBlock(_component_el_table, {
      key: `ac_g_${gi}`,
      data: g,
      border: "",
      "header-cell-style": {
        backgroundColor: '#4d93ef',
        color: 'white'
      },
      style: {
        "width": "100%",
        "margin-top": "16px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "idx",
        width: "60px",
        label: "序号"
      }), _createVNode(_component_el_table_column, {
        prop: "groupName",
        label: "所属小组"
      }), _createVNode(_component_el_table_column, {
        prop: "name",
        width: "200px",
        label: "姓名"
      }), _createVNode(_component_el_table_column, {
        prop: "qtfjw",
        label: "其他非警务"
      }), _createVNode(_component_el_table_column, {
        prop: "jb",
        label: "家暴"
      }), _createVNode(_component_el_table_column, {
        prop: "fz",
        label: "反诈"
      })]),
      _: 2
    }, 1032, ["data"]);
  }), 128)), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_15, _hoisted_16]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "     本周共出动" + _toDisplayString($data.shopCheckData?.checkerData ? Object.keys($data.shopCheckData.checkerData).length : 0) + "人，检查店铺数" + _toDisplayString($data.shopCheckData?.shopCnt) + "家次，发现问题店铺" + _toDisplayString($data.shopCheckData?.problemShopCnt) + "家， 对应问题共计" + _toDisplayString($data.shopCheckData?.problemCategories ? Object.keys($data.shopCheckData?.problemCategories).length : 0) + "项。", 1)]),
    _: 1
  }), _createVNode(_component_el_table, {
    data: $data.shopChecks,
    border: "",
    "header-cell-style": {
      backgroundColor: '#4d93ef',
      color: 'white'
    },
    style: {
      "width": "100%",
      "margin-top": "16px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "idx",
      width: "60px",
      label: "序号"
    }), _createVNode(_component_el_table_column, {
      prop: "shopName",
      label: "店铺名称"
    }), _createVNode(_component_el_table_column, {
      prop: "communityName",
      label: "所属社区"
    }), _createVNode(_component_el_table_column, {
      prop: "problemCategory",
      label: "检查类别"
    }), _createVNode(_component_el_table_column, {
      prop: "problem",
      label: "对应问题"
    }), _createVNode(_component_el_table_column, {
      prop: "checker",
      width: "200px",
      label: "检查人"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_17, _hoisted_18]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [$data.dangerCommunities ? (_openBlock(), _createBlock(_component_SinglePieChart, {
      key: 0,
      id: "fxsqfbqk",
      "pie-data": $data.dangerCommunities
    }, null, 8, ["pie-data"])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_19, _hoisted_20]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [$data.dangerTypes ? (_openBlock(), _createBlock(_component_SinglePieChart, {
      key: 0,
      id: "fxyhljfbqk",
      "pie-data": $data.dangerTypes
    }, null, 8, ["pie-data"])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_21, _hoisted_22]),
    _: 1
  }), _createVNode(_component_el_table, {
    data: $data.dangerCheckGroups,
    border: "",
    "header-cell-style": {
      backgroundColor: '#4d93ef',
      color: 'white'
    },
    style: {
      "width": "100%",
      "margin-top": "16px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "idx",
      label: "序号"
    }), _createVNode(_component_el_table_column, {
      prop: "groupGroupName",
      label: "所属小组"
    }), _createVNode(_component_el_table_column, {
      prop: "checkerCnt",
      label: "检查人数"
    }), _createVNode(_component_el_table_column, {
      prop: "checkTimes",
      label: "检查家次"
    }), _createVNode(_component_el_table_column, {
      prop: "problems",
      label: "发现问题数"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_23, _hoisted_24]),
    _: 1
  }), _createVNode(_component_el_table, {
    data: $data.dangerCheckers,
    border: "",
    "header-cell-style": {
      backgroundColor: '#4d93ef',
      color: 'white'
    },
    style: {
      "width": "100%",
      "margin-top": "16px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "idx",
      label: "序号"
    }), _createVNode(_component_el_table_column, {
      prop: "groupGroupName",
      label: "所属小组"
    }), _createVNode(_component_el_table_column, {
      prop: "userName",
      label: "姓名"
    }), _createVNode(_component_el_table_column, {
      prop: "checkTimes",
      label: "检查家次"
    }), _createVNode(_component_el_table_column, {
      prop: "problems",
      label: "发现问题数"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_25, _hoisted_26]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "     本周共完成上报事件数" + _toDisplayString($data.reportEventStatistic.total) + "次，较上周 " + _toDisplayString($data.reportEventStatistic.total > $data.reportEventStatistic.lastWeek ? '增加' : '减少') + " " + _toDisplayString(Math.abs($data.reportEventStatistic.total - $data.reportEventStatistic.lastWeek)) + "次。", 1)]),
    _: 1
  }), _createVNode(_component_el_table, {
    data: $data.reportEvents,
    border: "",
    "header-cell-style": {
      backgroundColor: '#4d93ef',
      color: 'white'
    },
    style: {
      "width": "100%",
      "margin-top": "16px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "idx",
      label: "序号"
    }), _createVNode(_component_el_table_column, {
      prop: "item",
      label: "工作事项"
    }), _createVNode(_component_el_table_column, {
      prop: "cnt",
      label: "本周数量"
    })]),
    _: 1
  }, 8, ["data"]), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_27, _hoisted_28]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [$data.bikeCleanData ? (_openBlock(), _createBlock(_component_SimpleVerticalBarChart, {
      key: 0,
      data: $data.bikeCleanData,
      id: "bikeCleanData"
    }, null, 8, ["data"])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_29, _hoisted_30]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [$data.shopData ? (_openBlock(), _createBlock(_component_SinglePieChart, {
      key: 0,
      id: "cdfbqk",
      "pie-data": $data.shopData
    }, null, 8, ["pie-data"])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "出店经营" + _toDisplayString($data.shopData ? $data.shopData.reduce((max, obj) => obj.value > max.value ? obj : max).name : '-') + "占比高，整治问题较为突出", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "leftCenter pdfLable mt20"
  }, {
    default: _withCtx(() => [_hoisted_31, _hoisted_32]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [$data.wzqlData ? (_openBlock(), _createBlock(_component_SimpleVerticalBarChart, {
      key: 0,
      id: "wzqlqk",
      data: $data.wzqlData
    }, null, 8, ["data"])) : _createCommentVNode("", true)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt16"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($data.topThreeWzjyNames) + "一带是无证商贩集聚地带", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "rightCenter mt100"
  }, {
    default: _withCtx(() => [_hoisted_33]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "rightCenter mt12"
  }, {
    default: _withCtx(() => [_hoisted_34]),
    _: 1
  })])]);
}